// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"332":"0cacbc9e","453":"a19606bb"}[chunkId] + ".chunk.js";
};